import NotificationsStore from "./NotificationsStore"

export default NotificationsStore
